export const formatMoney = (value) => {
  const sign = value < 0 ? '-' : '';
  const abs = Math.abs(value);

  if (abs >= 1_000_000_000) {
    return `R${sign}${(abs / 1_000_000_000).toFixed(2)}B`;
  }

  if (abs >= 1_000_000) {
    return `R${sign}${(abs / 1_000_000).toFixed(2)}M`;
  }

  return `R${sign}${abs.toLocaleString(undefined, {
    maximumFractionDigits: 2
  })}`;
};

export const formatTooltipMoney = (value) => {
  const sign = value < 0 ? '-' : '';
  const abs = Math.abs(value);

  if (abs >= 1_000_000_000) {
    return `R${sign}${(abs / 1_000_000_000).toFixed(4)}B`;
  }

  if (abs >= 1_000_000) {
    return `R${sign}${(abs / 1_000_000).toFixed(4)}M`;
  }

  if (abs >= 1_000) {
    return `R${sign}${(abs / 1_000).toFixed(4)}K`;
  }

  return `R${sign}${abs.toFixed(2)}`;
};

export default formatMoney;
